export const TABLE_LARGE_PLUS = `
  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="m12.35 20h-2.35v-3h2.09c.12-.72.37-1.39.72-2h-2.81v-3h4v1.54c.58-.54 1.25-.93 2-1.19v-.35h4v.35c.75.26 1.42.65 2
    1.19v-8.54c0-1.1-.9-2-2-2h-16c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h9.54c-.54-.58-.93-1.25-1.19-2m3.65-13h4v3h-4zm-6 0h4v3h-4zm-2
    13h-4v-3h4zm0-5h-4v-3h4zm0-5h-4v-3h4zm9 4h2v3h3v2h-3v3h-2v-3h-3v-2h3z"/>
  </svg>
`;
